import React from 'react';
import '../assets/styles/Footer.css'; // Adjust the path as necessary

const Footer = () => {
  return (
    <footer>
      <p>© 2025 BobTheSkull. All rights reserved.</p>
      <a href='https://ko-fi.com/H2H71D6YVZ' target='_blank'><img height = "36" src='https://storage.ko-fi.com/cdn/kofi3.png?v=6' border='0' alt='Buy Me a Coffee at ko-fi.com' /></a>
    </footer>
  );
};

export default Footer;